import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import type {PayloadAction} from '@reduxjs/toolkit'
import studentService from './studentService'
import axios from 'axios'

// Get StudentApplication
export const StudentStatistics = createAsyncThunk('student-statistics', async (_, thunkAPI) => {
  try {
    return await studentService.studentStatistics()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get StudentApplication
export const ListStudentApplication = createAsyncThunk(
  'student-application-list',
  async (params: {}, thunkAPI) => {
    try {
      return await studentService.studentApplicationList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create StudentApplication
export const CreateStudentApplication = createAsyncThunk(
  'student-application-create',
  async (data: {}, thunkAPI) => {
    try {
      return await studentService.studentApplicationCreate({data})
    } catch (error: any) {
      const message =
        error.response?.data?.errors ?? error.response?.data ?? error.message ?? 'Unknown error'
      return thunkAPI.rejectWithValue(message)
    }
  }
)

// Get StudentApplication by id
export const EditStudentApplication = createAsyncThunk(
  'student-application-edit',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.studentApplicationEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete StudentApplication
export const DeleteStudentApplication = createAsyncThunk(
  'student-application-delete',
  async (user_id: string, thunkAPI) => {
    try {
      return await studentService.studentApplicationDelete(user_id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete StudentApplication
export const GetProgramPayments = createAsyncThunk(
  'program-payments',
  async (program_id: string, thunkAPI) => {
    try {
      return await studentService.getProgramPayments(program_id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Toggle Archive StudentApplication
export const toggleArchiveStudentApplication = createAsyncThunk(
  'student-application-toggle',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.studentApplicationToggleArchive(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// ListArchivedApplicationStudent
export const ListArchivedApplicationStudent = createAsyncThunk(
  'archived-student-application-list',
  async (params: {}, thunkAPI) => {
    try {
      return await studentService.studentApplicationArchiveList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// view viewStudentApplication
export const viewStudentApplication = createAsyncThunk(
  'application-student-view',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.studentApplicationView(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentApplicationLetters = createAsyncThunk(
  'student-app-letters',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.studentApplicationLetters(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// PrintApplicationLetter
export const AppLetterView = createAsyncThunk('appl-letter-print', async (id: string, thunkAPI) => {
  try {
    return await studentService.appLetterView(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Student
export const ListStudent = createAsyncThunk('student-list', async (params: {}, thunkAPI) => {
  try {
    return await studentService.studentList({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete Student
export const DeleteStudent = createAsyncThunk(
  'student-delete',
  async (user_id: string, thunkAPI) => {
    try {
      return await studentService.studentDelete(user_id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Toggle Archive Student
export const toggleArchiveStudent = createAsyncThunk(
  'student-toggle',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.studentToggleArchive(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// view viewStudent
export const viewStudent = createAsyncThunk('student-view', async (id: string, thunkAPI) => {
  try {
    return await studentService.studentView(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Update Student
export const UpdateStudent = createAsyncThunk('student-update', async (data: {}, thunkAPI) => {
  try {
    return await studentService.studentUpdate({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Get Student by id
export const EditStudent = createAsyncThunk('student-edit', async (id: string, thunkAPI) => {
  try {
    return await studentService.studentEdit(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Email student
export const emailStudent = createAsyncThunk('student-email', async (data: {}, thunkAPI) => {
  try {
    return await studentService.studentEmail({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// ListArchivedStudent
export const ListArchivedStudent = createAsyncThunk(
  'archived-students-list',
  async (params: {}, thunkAPI) => {
    try {
      return await studentService.studentArchiveList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get StudentDocument
export const ListStudentDocument = createAsyncThunk(
  'student-document-list',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.studentDocumentList(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create StudentDocument
export const CreateStudentDocument = createAsyncThunk(
  'student-document-create',
  async (data: {}, thunkAPI) => {
    try {
      return await studentService.studentDocumentCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get StudentDocument by id
export const EditStudentDocument = createAsyncThunk(
  'student-document-edit',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.studentDocumentEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete StudentDocument
export const DeleteStudentDocument = createAsyncThunk(
  'student-document-delete',
  async (user_id: string, thunkAPI) => {
    try {
      return await studentService.studentDocumentDelete(user_id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get StudentNote
export const ListStudentNote = createAsyncThunk(
  'student-note-list',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.studentNoteList(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create StudentNote
export const CreateStudentNote = createAsyncThunk(
  'student-note-create',
  async (data: {}, thunkAPI) => {
    try {
      return await studentService.studentNoteCreate({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get StudentNote by id
export const EditStudentNote = createAsyncThunk(
  'student-note-edit',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.studentNoteEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete StudentNote
export const DeleteStudentNote = createAsyncThunk(
  'student-note-delete',
  async (user_id: string, thunkAPI) => {
    try {
      return await studentService.studentNoteDelete(user_id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Delete StudentNote
export const StudentInvoices = createAsyncThunk(
  'student-invoices',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.studentInvoices(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Get StudentApplication by id
export const GetRegAppEmail = createAsyncThunk('ge-reg-app-email', async (id: string, thunkAPI) => {
  try {
    return await studentService.getRegAppEmail(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create StudentApplication
export const AppEmail = createAsyncThunk('application-email', async (data: {}, thunkAPI) => {
  try {
    return await studentService.ApplicationEmail({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete letter
export const DeleteLetter = createAsyncThunk('letter-delete', async (id: string, thunkAPI) => {
  try {
    return await studentService.letterDelete(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StdLetterDelete = createAsyncThunk(
  'std-letter-delete',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.stdLetterDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// View Letter
export const ViewStudentLetter = createAsyncThunk(
  'view-student-letter',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.studentLetterView(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create Letter
export const CreateStudentLetter = createAsyncThunk('create-letter', async (data: {}, thunkAPI) => {
  try {
    return await studentService.studentLetterCreate({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Toggle Archive student
export const toggleStudentLetter = createAsyncThunk(
  'student-letter-toggle',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.studentLetterToggle(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentProfile = createAsyncThunk('std-profile', async (_, thunkAPI) => {
  try {
    return await studentService.studentProfile()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentDocument = createAsyncThunk('std-documents', async (_, thunkAPI) => {
  try {
    return await studentService.studentDocuments()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentLetter = createAsyncThunk('std-letters', async (_, thunkAPI) => {
  try {
    return await studentService.studentLetters()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const MyVids = createAsyncThunk('std-my-videos', async (_, thunkAPI) => {
  try {
    return await studentService.myVideoLibrary()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const SearchVideos = createAsyncThunk(
  'std-video-search',
  async ({type, program, section}: {type: string; program: string; section: string}, thunkAPI) => {
    try {
      return await studentService.myVideoSearch(type, program, section)
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ListMyPub = createAsyncThunk('my-pub-list', async (_, thunkAPI) => {
  try {
    return await studentService.myPublicationList()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Create publication
export const createMyPub = createAsyncThunk('my-pub-create', async (data: {}, thunkAPI) => {
  try {
    return await studentService.myPublicationCreate({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListPub = createAsyncThunk(
  'student-publication-list',
  async (params: {}, thunkAPI) => {
    try {
      return await studentService.pubList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const MyInvoices = createAsyncThunk('my-invoices', async (_, thunkAPI) => {
  try {
    return await studentService.myInvoices()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentRegulations = createAsyncThunk('std-regulations', async (_, thunkAPI) => {
  try {
    return await studentService.studentRegulations()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentNews = createAsyncThunk('std-news', async (_, thunkAPI) => {
  try {
    return await studentService.studentNews()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StduentCourses = createAsyncThunk('std-courses', async (_, thunkAPI) => {
  try {
    return await studentService.myCourses()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const MyAttendance = createAsyncThunk('my-attendance', async (id: string, thunkAPI) => {
  try {
    return await studentService.myAttendance(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const LecturerInfo = createAsyncThunk('lecturer-info', async (id: string, thunkAPI) => {
  try {
    return await studentService.lecturerInfo(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const MyTranscript = createAsyncThunk('my-transcript', async (_, thunkAPI) => {
  try {
    return await studentService.myTranscript()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const Alumnistudent = createAsyncThunk('alumni-student', async (id: string, thunkAPI) => {
  try {
    return await studentService.alumniStudent(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ListAlumniStudents = createAsyncThunk(
  'alumni-student-list',
  async (params: {}, thunkAPI) => {
    try {
      return await studentService.alumniStudentList({params})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const AlumniStudentDetails = createAsyncThunk(
  'alumni-student-details',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.alumniStudentDetails(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentUpgrade = createAsyncThunk('upgrade-student', async (data: {}, thunkAPI) => {
  try {
    return await studentService.studentUpgrade({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const SubmitStudentAssignment = createAsyncThunk(
  'std-submit-assignment',
  async (data: {}, thunkAPI) => {
    try {
      return await studentService.submitAssignment({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const MyTranscriptPrint = createAsyncThunk(
  'transcript-print-std-portal',
  async ({lang, studentId}: {lang: string; studentId: string}, thunkAPI) => {
    try {
      return await studentService.transcriptPrint(lang, studentId)
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentTranscriptPrint = createAsyncThunk(
  'student-transcript-print-admin-portal',
  async ({lang, studentId}: {lang: string; studentId: string}, thunkAPI) => {
    try {
      return await studentService.studentTranscriptPrint(lang, studentId)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentTranscript = createAsyncThunk(
  'student-transcript-admin-portal',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.studentTranscript(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetCourseEvaluationDetails = createAsyncThunk(
  'get-course-ev-details',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.getCourseEvDetails(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StoreEvaluationForm = createAsyncThunk('ev-form-store', async (data: {}, thunkAPI) => {
  try {
    return await studentService.evFormStore({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StdEvaluationFromGraph = createAsyncThunk('ev-graph', async (id: string, thunkAPI) => {
  try {
    return await studentService.stdEvalutationFormGraph(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const StudentAnnualFeedback = createAsyncThunk(
  'std-annual-feedback',
  async (_, thunkAPI) => {
    try {
      return await studentService.annualFeeback()
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetAnnualFeeback = createAsyncThunk(
  'get-std-annual-feedback',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.getAnnualFeeback(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StoreAnnualForm = createAsyncThunk('ev-form-store', async (data: {}, thunkAPI) => {
  try {
    return await studentService.storeAnnualForm({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const CreateAppLetter = createAsyncThunk('create-app-letter', async (data: {}, thunkAPI) => {
  try {
    return await studentService.createAppLetter({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const MoveAppToStdudent = createAsyncThunk('move-app-to-std', async (data: {}, thunkAPI) => {
  try {
    return await studentService.moveAppToStd({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetAppList = createAsyncThunk('get-app-list', async (_, thunkAPI) => {
  try {
    return await studentService.getAppList()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetStdList = createAsyncThunk('get-std-list', async (_, thunkAPI) => {
  try {
    return await studentService.getStdList()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const CreateUserForStds = createAsyncThunk(
  'create-user-for-std',
  async (data: {}, thunkAPI) => {
    try {
      return await studentService.createUserForStds({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const SkipEvForm = createAsyncThunk('skip-ev-form', async (id: string, thunkAPI) => {
  try {
    return await studentService.skipEvForm(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ApplicationLetterEmail = createAsyncThunk(
  'app-letter-mail',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.applicationLetterEmail(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StudentLetterEmail = createAsyncThunk(
  'std-letter-mail',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.studentLetterEmail(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ImportExcelStudents = createAsyncThunk(
  'import-student-excel',
  async (data: {}, thunkAPI) => {
    try {
      return await studentService.importExcelStudents({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const AYAndIntake = createAsyncThunk('academic-year-intake', async (_, thunkAPI) => {
  try {
    return await studentService.aYAndIntake()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const RelatedPrograms = createAsyncThunk(
  'related-programs',
  async (
    {academic_year_id, intake_id}: {academic_year_id: string; intake_id: string},
    thunkAPI
  ) => {
    try {
      return await studentService.relatedPrograms(academic_year_id, intake_id)
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const StdRelatedPrograms = createAsyncThunk(
  'std-related-programs',
  async (
    {academic_year_id, intake_id}: {academic_year_id: string; intake_id: string},
    thunkAPI
  ) => {
    try {
      return await studentService.stdRelatedPrograms(academic_year_id, intake_id)
    } catch (error: any) {
      if (error.response?.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const CreateGroupLetter = createAsyncThunk(
  'create-group-letter',
  async (data: {}, thunkAPI) => {
    try {
      return await studentService.createGroupLetter({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const RelatedApplications = createAsyncThunk('related-apps', async (data: {}, thunkAPI) => {
  try {
    return await studentService.relatedApplications({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const UpdateAndEmailStdAccount = createAsyncThunk(
  'update-account-and-mail',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.updateAndEmailStdAccount(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const RelatedStudents = createAsyncThunk('related-students', async (data: {}, thunkAPI) => {
  try {
    return await studentService.relatedStudents({data})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const CreateGroupLetterStd = createAsyncThunk(
  'create-group-letter-std',
  async (data: {}, thunkAPI) => {
    try {
      return await studentService.createGroupLetterStd({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const EditStdProfile = createAsyncThunk('edit-profile', async (_, thunkAPI) => {
  try {
    return await studentService.editStdProfile()
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const updateStdProfile = createAsyncThunk(
  'update-std-profile',
  async (data: {}, thunkAPI) => {
    try {
      return await studentService.updateStdProfile({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OnlineApplications = createAsyncThunk('online-apps', async (params: {}, thunkAPI) => {
  try {
    return await studentService.onlineApplications({params})
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const OnlineApplicationDelete = createAsyncThunk(
  'online-app-delete',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.onlineApplicationDelete(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const OnlineApplication = createAsyncThunk('online-app', async (id: string, thunkAPI) => {
  try {
    return await studentService.onlineApplication(id)
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const ChangeOnlineApp = createAsyncThunk(
  'change-online-app',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.changeOnlineApp(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ChangeOnlineApplication = createAsyncThunk(
  'change-online-application',
  async (data: {}, thunkAPI) => {
    try {
      return await studentService.changeOnlineApplication({data})
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const ListStudentCard = createAsyncThunk(
  'student-card-list',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.studentCardList(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

// Create StudentApplication
export const CreateStudentCard = createAsyncThunk(
  'student-card-create',
  async (data: {}, thunkAPI) => {
    try {
      return await studentService.studentCardCreate({data})
    } catch (error: any) {
      const message =
        error.response?.data?.errors ?? error.response?.data ?? error.message ?? 'Unknown error'
      return thunkAPI.rejectWithValue(message)
    }
  }
)

// Get StudentCard by id
export const EditStudentCard = createAsyncThunk(
  'student-card-edit',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.studentCardEdit(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const InactiveStudentcard = createAsyncThunk(
  'inactive-student-card',
  async (id: string, thunkAPI) => {
    try {
      return await studentService.studentCardInactive(id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetAyApps = createAsyncThunk('get-ay-apps', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student-application/get-ay-apps/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

// Delete StudentCard
export const DeleteStudentCard = createAsyncThunk(
  'student-card-delete',
  async (user_id: string, thunkAPI) => {
    try {
      return await studentService.studentCardDelete(user_id)
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const GetAyProApps = createAsyncThunk('getAyProApps', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/student-application/get-pro-ay-apps', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetAyStudents = createAsyncThunk('get-ay-stds', async (id: string, thunkAPI) => {
  try {
    const response = await axios.get(`/api/student/get-ay-stds/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const GetAyProStudents = createAsyncThunk('getAyProStudents', async (data: {}, thunkAPI) => {
  try {
    const res = await axios.post('/api/student/get-pro-ay-stds', data)
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

export const Planning = createAsyncThunk('planning', async (_, thunkAPI) => {
  try {
    const res = await axios.get('/api/std/planning')
    return res.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type StudentState = {
  record: any
  records: any
  errors: any
}

const initialState: StudentState = {
  records: {
    data: [],
  },
  record: {},
  errors: '',
}
export const studentSlice = createSlice({
  name: 'student',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(ListStudentApplication.fulfilled, (state, action: PayloadAction<any>) => {
      state.records = action.payload
    })
    builder.addCase(
      ListArchivedApplicationStudent.fulfilled,
      (state, action: PayloadAction<any>) => {
        state.records = action.payload
      }
    )
    builder.addCase(ListStudent.fulfilled, (state, action: PayloadAction<any>) => {
      state.records = action.payload
    })
    builder.addCase(ListArchivedStudent.fulfilled, (state, action: PayloadAction<any>) => {
      state.records = action.payload
    })
    builder.addCase(ListAlumniStudents.fulfilled, (state, action: PayloadAction<any>) => {
      state.records = action.payload
    })
  },
})

export const {reset} = studentSlice.actions
export default studentSlice.reducer
